import React from 'react';

import classNames from 'classnames';

import LoadingSpinner from '../LoadingSpinner';

import style from './style.module.scss';

type LoadingOverlayType = {
	fixed?: boolean;
};

const LoadingOverlay: React.FC<LoadingOverlayType> = ({ fixed }) => {
	return (
		<div className={classNames([style.LoadingOverlay, fixed && style.fixed])}>
			<LoadingSpinner />
		</div>
	);
};

export default LoadingOverlay;
